import { render, staticRenderFns } from "./AddToSalesForce.vue?vue&type=template&id=29ca9b2a&scoped=true"
import script from "./AddToSalesForce.vue?vue&type=script&lang=js"
export * from "./AddToSalesForce.vue?vue&type=script&lang=js"
import style0 from "./AddToSalesForce.vue?vue&type=style&index=0&id=29ca9b2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ca9b2a",
  null
  
)

export default component.exports